var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('icon',_vm._b({staticClass:"c-icon",attrs:{"icon":_vm.icon,"width":'' + _vm.size,"height":'' + _vm.size}},'icon',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }